const appendModalToBody = () => {
  const modalHtml = `
    <div class="modal">
      <div class="modal-overlay"></div>
      <div class="modal-content">
            <button class="modal-close">×</button>
            <div class="modal-content-inner"></div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHtml);
}

const modal = () => {
  const modalTriggers = document.querySelectorAll('[data-modal-trigger]');

  if (!modalTriggers.length) {
    return;
  }

  let modal = document.querySelector('.modal');
  if(!modal) {
    appendModalToBody();
  }
  modal = document.querySelector('.modal');

  //clear modal
  modal.querySelector('.modal-content-inner').innerHTML = '';

  const openModal = (trigger, ajaxUrl = null) => {
    const modal = document.querySelector('.modal');

    console.log('openModal', modal);

    if (!modal) {
      console.error(`Modal element not found.`);
      return;
    }

    const modalContent = modal.querySelector('.modal-content');
    const modalContentInner = modal.querySelector('.modal-content-inner');
    const modalOverlay = modal.querySelector('.modal-overlay');
    const closeButton = modal.querySelector('.modal-close');

    if (!(modalContent && modalOverlay && closeButton && modalContentInner)) {
      console.error('Modal structure is incomplete.');
      return;
    }

    // Show the modal
    modal.classList.add('visible');

    // Load content via AJAX if `ajaxUrl` is provided
    if (ajaxUrl) {
      modalContentInner.innerHTML = '<p>Loading...</p>'; // Temporary loading content
      fetch(ajaxUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then((response) => {
          const json = JSON.parse(response);
          modalContentInner.innerHTML = json.html;
        })
        .catch((error) => {
          console.error('Error loading content:', error);
          modalContentInner.innerHTML =
            '<p class="errror">Failed to load content. Please try again later.</p>';
        });
    }

    // Close modal on overlay click or close button click
    const closeModal = () => {
      modal.classList.remove('visible');
      modalContentInner.innerHTML = ''; // Clear content after closing
    };

    modalOverlay.addEventListener('click', closeModal, { once: true });
    closeButton.addEventListener('click', closeModal, { once: true });
  };

  modalTriggers.forEach((trigger) => {
    if (!trigger.classList.contains('event-attached')) {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const ajaxUrl = trigger.getAttribute('data-ajax-url'); // Get AJAX URL if provided
        openModal(trigger, ajaxUrl);
      });
      trigger.classList.add('event-attached');
    }
  });
};

export default modal;
